export default __webpack_public_path__ + "static/media/TextLogoSquare.a4ff3563.svg";